import { customFetch } from '../../../../../shared/customFetch';
import { API_ROUTES } from '../../../../shared/ApiRoutes';

export const updateOperation = (userId: string, opeId: string, ope: any) => {
  return customFetch.post(API_ROUTES.OPERATION.UPDATE(userId, opeId), ope);
};

export const deleteOperation = (userId: string, opeId: string) => {
  return customFetch.get(API_ROUTES.OPERATION.DELETE(userId, opeId));
};

export const finalizeTransaction = (
  transactionId: string,
  dataToCreate: any,
) => {
  return customFetch.post(
    API_ROUTES.OPERATION.FINALIZE_TRANSACTION(transactionId),
    dataToCreate,
  );
};
